import { render, staticRenderFns } from "./PageColumnWithCustomerEditor.vue?vue&type=template&id=355cd3ff&lang=pug&"
import script from "./PageColumnWithCustomerEditor.vue?vue&type=script&lang=ts&"
export * from "./PageColumnWithCustomerEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PageColumnWithCustomerEditor.vue?vue&type=style&index=0&id=355cd3ff&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports